import * as React from "react";
import AboutBgImg from "../../assets/robocup2026/web/robots_flag.jpg";

function About() {
  return (
    <section className="trps-section trps-dark" id="About">
      <div className="trps-wrap">
        <h2 className="trps-h">私たちについて</h2>

        <div className="trps-split trps-split--section trps-split--top">
          <div>
            <p className="trps-sub" style={{ marginTop: 0 }}>
              RoboCupチームTRAPSは、豊田高専KIKS出身者を中心に、
              様々なバックグラウンドを持つメンバーで結成されました。
            </p>
            <p className="trps-sub">
              これまでのRoboCupにおける数々の研究成果や、メンバーが磨いてきたスキルを受け止め（trap）、
              高度なロボットサッカー実現に向けた次の一手へ繋げることを目指しています。
            </p>
          </div>

          <div className="trps-split__media">
            <img
              src={AboutBgImg}
              alt="TRAPSのフラッグと積み上げられたロボット"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
